import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import Button from '../../formElements/Button';

import AuditActionPlanManagement from './AuditActionPlanManagement';

import modal from '../../../commonStyles/modal.module.css';

const AuditActionPlanModal = ({ modalHeadingLabel, isOpen, onClose }) => {
    // RENDER
    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            onClick={(e) => e.stopPropagation()}
            className="muiDialogWrapper"
            id="auditModal">
            <div className={modal.modalHeader}>
                <DialogTitle>{modalHeadingLabel} Change History</DialogTitle>
            </div>
            <DialogContent>
                <>
                    <div className={modal.mainContent}>
                        <AuditActionPlanManagement />
                    </div>
                    <div className={modal.actionButtons}>
                        <div className={modal.cancelButton}>
                            <Button id="auditModalButton" onClick={onClose} content="Close" />
                        </div>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    );
};

AuditActionPlanModal.propTypes = {
    modalHeadingLabel: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired
};

export default AuditActionPlanModal;
